// globalVars.ts
// defineGlobal window 注册全局

function defineGlobal(name: string, value: any) {
    (window as any)[name] = value;
}

export default defineGlobal
